import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";
import img from "../../assets/img/brand/goodybuddy_short.png";
import AddButton from "components/Button/AddButton";
import BackButton from "components/Button/BackButton";

const BookingUserInfo = ({data}) => {
    const navigate = useNavigate();
    
  return (
    <Row className="justify-content-center align-items-stretch">
    {/* Left Card: Profile Image */}
    <Col md="4" sm="12" className="d-flex">
      <Card className="shadow flex-fill">
        <CardBody className="d-flex flex-column align-items-center justify-content-center">
          <img
            src={data?.profileImage || img}
            alt={`${data?.firstName} ${data?.lastName}`}
            className="rounded-circle mb-3"
            width="150"
            height="150"
          />
          <CardTitle tag="h2">
            {data?.firstName} {data?.lastName}
          </CardTitle>
        </CardBody>
      </Card>
    </Col>

    {/* Right Card: Details */}
    <Col md="8" sm="12" className="d-flex">
      <Card className="shadow flex-fill">
        <CardBody>
          <Row className="mb-2">
            <Col md="4" sm="4">
              <strong>Email:</strong>
            </Col>
            <Col md="8" sm="8">
              {data?.email}
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md="4" sm="4">
              <strong>Mobile:</strong>
            </Col>
            <Col md="8" sm="8">
              {data?.mobileNo}
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md="4" sm="4">
              <strong>Date of Birth:</strong>
            </Col>
            <Col md="8" sm="8">
              {new Date(data?.dob).toLocaleDateString(
                "en-GB"
              )}
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md="4" sm="4">
              <strong>Account Created On:</strong>
            </Col>
            <Col md="8" sm="8">
              {new Date(data?.createdAt).toLocaleDateString(
                "en-GB"
              )}
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md="4" sm="4">
              <strong>Type:</strong>
            </Col>
            <Col md="8" sm="8">
              Buddy
            </Col>
          </Row>
          <div className="text-center mt-3">
            <div className="d-flex justify-content-between align-items-center">
              
              <AddButton
                title="More Info"
                onClick={() =>
                  navigate("/admin/user/view/" + data?._id)
                }
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  </Row>
  )
}

export default BookingUserInfo
